export default "__VITE_ASSET__fb89f59c__"